export const AdCardIndexList = [2, 6, 9];
export const AdCardIndexSet = new Set(AdCardIndexList);

export const SubSectionList = [
  "trends",
  "luxury",
  "celeb",
  "kpop",
  "leisure",
  "well",
  "tech",
] as const;
export type SubSection = (typeof SubSectionList)[number];
